import { useState, useEffect } from "react";
import Navbar from "../components/navbar";
import logo from "../assets/extended-white.png";
import "../stylesheets/Home.css";

import hero1 from "../assets/hero/hero1.jpg";
import hero2 from "../assets/hero/hero2.jpg";

import aceroIcon from "../assets/categorias/acero.png";
import polvosIcon from "../assets/categorias/polvos.png";
import maderaIcon from "../assets/categorias/madera.png";
import electricoIcon from "../assets/categorias/electrico.png";
import herramientasIcon from "../assets/categorias/herramientas.png";
import ligerosIcon from "../assets/categorias/ligeros.png";
import plomeriaIcon from "../assets/categorias/plomeria.png";

function Home() {
    const [showNavbar, setShowNavbar] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const handleScroll = () =>
            setShowNavbar(window.scrollY > window.innerHeight - 10);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // 👇 Importa las imágenes directamente (así React sí las encuentra)
    const heroImages = [hero1, hero2];

    // Cambio automático de imagen cada 6 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % heroImages.length);
        }, 6000);
        return () => clearInterval(interval);
    }, [heroImages.length]);

    const categories = [
        {
            name: "Acero",
            img: aceroIcon,
            products: [
                "Varilla 3/8", "Varilla 1/2", "Varilla 5/8", "Varilla 3/4", "Varilla 1\"",
                "Alambre recocido", "Alambrón", "Clavo",
                "Malla soldada 66/10", "Malla soldada 66/66", "Malla soldada 66/44", "Malla soldada 66/88",
                "Castillo 15x15", "Castillo 15x20"
            ]
        },
        {
            name: "Polvos",
            img: polvosIcon,
            products: [
                "Cemento CEMEX gris 50kg", "Cemento CEMEX gris 25kg", "Cemento CEMEX blanco 25kg",
                "Cemento CEMEX blanco 50kg", "Mortero CEMEX 50kg", "Asfalto CEMEX en frío 25kg",
                "Cemento CEMEX antihumedad 25kg", "Cemento Apasco 50kg", "Cemento Apasco 25kg",
                "Estuco blanco 25kg", "Yeso Máximo 40kg", "Cal 25kg",
                "Adhesivos Bexel", "Boquillas Bexel", "Adhesivos CREST", "Boquillas CREST"
            ]
        },
        {
            name: "Madera",
            img: maderaIcon,
            products: [
                "Triplay 12mm", "Triplay 15mm", "Triplay 18mm", "Triplay Film Face 15mm",
                "Triplay Film Face 18mm", "Tablas (diferentes medidas)", "Barrotes (diferentes medidas)",
                "Polines (diferentes medidas)", "Chaflán 1\"", "Panel Aislasin"
            ]
        },
        {
            name: "Material Eléctrico",
            img: electricoIcon,
            products: [
                "Cable", "Contactos", "Apagadores", "Rocetas", "Canaletas",
                "Tubo Conduit", "Conectores Conduit", "Poliducto 1/2 100mts", "Poliducto 3/4 100mts",
                "Poliducto corrugado 50mts 1/2", "Poliducto corrugado 50mts 3/4", "Chalupas 2x4",
                "Cajas 4x4", "Cajas hexagonales", "Guías para cable", "Cable uso rudo"
            ]
        },
        {
            name: "Herramientas",
            img: herramientasIcon,
            products: [
                "Pulidores", "Rotomartillo", "Esmeriladores", "Taladros", "Rotomartillos SDS",
                "Lijadoras orbitales", "Sierras circulares", "Sierras eléctricas de mesa", "Sierra caladora"
            ]
        },
        {
            name: "Sistemas Ligeros",
            img: ligerosIcon,
            products: [
                "Casetón 15x20x40", "Casetón 7x20x40", "Casetón 10x20x40", "Casetón 25x20x40",
                "Postes metálicos", "Canal de carga", "Canal de amarre", "Cinta de papel", "Perfacinta",
                "Ángulos", "Tablaroca", "Paneles Durock", "Tablaroca antihumedad", "Redimix",
                "Pijas negras", "Pijas framer"
            ]
        },
        {
            name: "Plomería",
            img: plomeriaIcon,
            products: [
                "TuboPlus: Codos", "Coples", "Tubos 1/2, 3/4, 1\"", "Conectores macho", "Conectores hembra",
                "Termofusora", "Codo pipa", "Válvulas", "Tapón"
            ]
        }
    ];

    return (
        <>
            <Navbar visible={showNavbar} />

            {/* HERO CON CARRUSEL OSCURO */}
            <section
                className="hero"
                style={{ "--hero-bg": `url(${heroImages[currentImage]})` }}
            >
                <div
                    className="hero-bg"
                    style={{
                        backgroundImage: `url(${heroImages[currentImage]})`,
                    }}
                ></div>
                <div className="hero-overlay"></div>

                <img src={logo} alt="SICOR Logo" className="hero-logo" />
                <h1>Bienvenidos</h1>
                <p>
                    Más que materiales, soluciones para tu obra.
                </p>
            </section>

            {/* NO TOCAMOS NADA DE LO DEMÁS */}
            <section className="services">
                <h2>Nuestros Servicios</h2>
                <div className="services-container">
                    <div className="service-card">
                        <h3>Venta al Mayoreo</h3>
                        <p>Materiales de construcción para grandes proyectos, con atención personalizada.</p>
                    </div>
                    <div className="service-card">
                        <h3>Venta al Menudeo</h3>
                        <p>Artículos individuales o por menor, siempre disponibles para tu necesidad.</p>
                    </div>
                    <div className="service-card">
                        <h3>Asesoría y Soluciones</h3>
                        <p>Te ayudamos a encontrar los materiales exactos que tu proyecto requiere.</p>
                    </div>
                </div>
            </section>

            <section className="categories">
                <h2>Categorías de Productos</h2>
                <div className="categories-container limited-width">
                    {categories.map((cat, idx) => (
                        <div
                            key={idx}
                            className="category-card enhanced"
                            onClick={() => setActiveCategory(cat)}
                        >
                            <img src={cat.img} alt={cat.name} className="category-icon" />
                            <h3>{cat.name}</h3>
                        </div>
                    ))}
                </div>
            </section>

            {activeCategory && (
                <div className="modal-backdrop" onClick={() => setActiveCategory(null)}>
                    <div
                        className="modal-content modal-animate"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2>{activeCategory.name}</h2>
                        <div className="modal-products">
                            {activeCategory.products.map((p, i) => (
                                <div key={i} className="modal-product-card">
                                    <h4>{p}</h4>
                                </div>
                            ))}
                        </div>
                        <button onClick={() => setActiveCategory(null)}>Cerrar</button>
                    </div>
                </div>
            )}

            <section className="about-us">
                <div className="about-content">
                    <div className="about-text">
                        <h2>Quiénes Somos</h2>
                        <p>
                            En <strong>SICOR</strong>, somos una empresa de Saltillo, Coahuila, dedicada a la venta de materiales para construcción al mayoreo y menudeo. Nos distingue la atención personalizada, la disponibilidad inmediata y la confianza que construimos con cada cliente. </p> <p> Creemos en la importancia de ofrecer soluciones prácticas y materiales de calidad, sin perder el trato humano y cercano que nos caracteriza. Cada proyecto, sin importar su tamaño, merece el mejor servicio.
                        </p>
                    </div>

                    <div className="about-image">
                        <div className="about-image-frame">
                            <img src={hero1} alt="Equipo SICOR" />
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default Home;
